import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { type TonTransactionDataType } from '@/common/types/userType';
import { StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

import { EarningsItem } from './EarningsItem';

import css from './styles.module.scss';

import usdPng from '/img/icons/usd.png';
import usdWebp from '/img/icons/usd.webp';

interface EarningsTableProps {
  transactionList?: TonTransactionDataType[];
}

const EarningsTable: FC<EarningsTableProps> = ({ transactionList }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full px-4 flex flex-col h-[25rem] overflow-y-auto">
      <div className={css.tableHead}>
        <StringSmall className="!text-[14px] !text-white/40">
          {t('From')}
        </StringSmall>
        <StringSmall className="!text-[14px] !text-white/40">
          {t('When')}
        </StringSmall>
        <div className="flex items-center justify-end gap-1">
          <StringSmall className="!text-[14px] !text-white/40">
            {t('Amount')}
          </StringSmall>
          <Picture
            className="w-6 h-6 shrink-0"
            img={usdPng}
            webp={usdWebp}
            alt="toncoin"
          />
        </div>
      </div>
      {transactionList?.map((props, index) => (
        <EarningsItem key={index} {...props} />
      ))}
    </div>
  );
};

export { EarningsTable };
